import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { DefaultModalComponent } from './default-modal';

export const DefaultModalModule: string = ng
    .module('archiSmall.components.defaultModalModule', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('defaultModalComponent', DefaultModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/default-modal/default-modal.module.ts